export enum Permission {
  ConnectApiKeysView = 'connect_api_keys.view',
  ConnectApiKeysModify = 'connect_api_keys.modify',
  ConnectApiKeysApprove = 'connect_api_keys.approve',
}
